module.exports = __webpack_public_path__ + "static/img/github.dd24e5c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/github.png
// module id = s65f
// module chunks = 1